var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllNewterms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.333,
    height: 91.603,
    viewBox: "0 0 331.333 91.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NewTerms",
    transform: "translate(-132.322 192.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6750",
    "data-name": "Group 6750",
    transform: "translate(132.322 -192.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281774",
    "data-name": "Path 281774",
    d: "M435.933-175.584A33.28,33.28,0,0,0,394.126-186.2h0a33.279,33.279,0,0,1-26.686,1.157l-2.18-.844a97.289,97.289,0,0,0-70.7.162l-14.779,5.8a33.282,33.282,0,0,1-25.227-.369l-9.416-4.019a80.935,80.935,0,0,0-70.108,3.163h0a49.51,49.51,0,0,0-21.357,64.658l4.694,9.987H435.2l3.557-6.106a58.2,58.2,0,0,0-2.821-62.975Z",
    transform: "translate(-132.148 192.457)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749",
    transform: "translate(178.525 7.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6744",
    "data-name": "Group 6744",
    transform: "translate(10.962 15.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281775",
    "data-name": "Path 281775",
    d: "M410.878-106.753l10.345-40.315-83.467-21.418-15.84,61.732Z",
    transform: "translate(-319.828 170.507)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281776",
    "data-name": "Path 281776",
    d: "M321.937-106.732l15.84-61.732,83.468,21.417L410.9-106.732h2.087L423.2-146.545A2.02,2.02,0,0,0,421.746-149l-83.468-21.417a2.017,2.017,0,0,0-.5-.065,2.022,2.022,0,0,0-1.956,1.52L319.85-106.732Z",
    transform: "translate(-319.85 170.486)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745",
    transform: "translate(5.597 6.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281777",
    "data-name": "Path 281777",
    d: "M316.627-106.638,334.8-177.464l83.468,21.417-12.679,49.409h2.087l12.55-48.907A2.021,2.021,0,0,0,418.771-158L335.3-179.421a2.018,2.018,0,0,0-.5-.065,2.022,2.022,0,0,0-1.956,1.52l-18.3,71.328Z",
    transform: "translate(-314.54 179.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281778",
    "data-name": "Path 281778",
    d: "M405.568-106.659l12.678-49.409-83.467-21.418-18.174,70.826Z",
    transform: "translate(-314.518 179.507)",
    fill: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_281779",
    "data-name": "Path 281779",
    d: "M400.028-106.6l14.234-55.472L330.8-183.485,311.066-106.6Z",
    transform: "translate(-308.979 185.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281780",
    "data-name": "Path 281780",
    d: "M402.637-117.445,400.03-107.28H311.07l2.728-10.65,4.315.02,1.3.01,15.035.081.829.01,22.523.121,8.316.04Z",
    transform: "translate(-308.979 186.192)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281781",
    "data-name": "Path 281781",
    d: "M311.088-106.575l19.729-76.889,83.468,21.417L400.05-106.575h2.087l14.1-54.969A2.02,2.02,0,0,0,414.787-164l-83.468-21.417a2.018,2.018,0,0,0-.5-.065,2.022,2.022,0,0,0-1.956,1.52L309-106.575Z",
    transform: "translate(-309.001 185.486)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Terms_Conditions",
    "data-name": "Terms & Conditions",
    transform: "translate(22.377 17.35) rotate(13.842)",
    fontSize: 11,
    fontFamily: "Arial-Black, Arial Black",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Terms &amp;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Conditions")), /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746",
    transform: "translate(7.153 40.655)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28468",
    "data-name": "Rectangle 28468",
    width: 2.021,
    height: 76.301,
    transform: "translate(9.342 1.958) rotate(-75.608)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28469",
    "data-name": "Rectangle 28469",
    width: 2.021,
    height: 76.301,
    transform: "translate(7.785 7.423) rotate(-75.608)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28470",
    "data-name": "Rectangle 28470",
    width: 2.021,
    height: 76.301,
    transform: "translate(4.671 18.353) rotate(-75.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281782",
    "data-name": "Path 281782",
    d: "M360.726-107.277h-8.144L317.62-116.25l.424-1.657.081-.3,1.223.313Z",
    transform: "translate(-316.064 145.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281783",
    "data-name": "Path 281783",
    d: "M337.885-107.334h-8.144L316.08-110.84l.505-1.96Z",
    transform: "translate(-316.08 145.591)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28471",
    "data-name": "Rectangle 28471",
    width: 2.021,
    height: 29.257,
    transform: "matrix(0.249, -0.969, 0.969, 0.249, 6.228, 12.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28472",
    "data-name": "Rectangle 28472",
    width: 2.021,
    height: 16.5,
    transform: "matrix(0.249, -0.969, 0.969, 0.249, 3.115, 23.819)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_281784",
    "data-name": "Path 281784",
    d: "M454.272-106.37H451.2a1.01,1.01,0,0,1-1.01-1.01,1.01,1.01,0,0,1,1.01-1.01h3.069a1.01,1.01,0,0,1,1.01,1.01A1.01,1.01,0,0,1,454.272-106.37Z",
    transform: "translate(-129.002 193.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281785",
    "data-name": "Path 281785",
    d: "M449-106.37H147.927a1.01,1.01,0,0,1-1.01-1.01,1.01,1.01,0,0,1,1.01-1.01H449a1.01,1.01,0,0,1,1.01,1.01A1.01,1.01,0,0,1,449-106.37Z",
    transform: "translate(-132.17 193.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281786",
    "data-name": "Path 281786",
    d: "M143.215-106.37h-9.882a1.01,1.01,0,0,1-1.01-1.01,1.01,1.01,0,0,1,1.01-1.01h9.882a1.01,1.01,0,0,1,1.01,1.01A1.01,1.01,0,0,1,143.215-106.37Z",
    transform: "translate(-132.322 193.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281787",
    "data-name": "Path 281787",
    d: "M459.241-106.37a1.025,1.025,0,0,1-1.029-1.01.994.994,0,0,1,.991-1.01h.037a1.01,1.01,0,0,1,1.01,1.01A1.01,1.01,0,0,1,459.241-106.37Z",
    transform: "translate(-128.918 193.335)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757",
    transform: "translate(159.435 -182.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754",
    transform: "translate(8.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6751",
    "data-name": "Group 6751",
    transform: "translate(24.008 0.197)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28473",
    "data-name": "Rectangle 28473",
    width: 17.442,
    height: 7.96,
    rx: 3.939,
    transform: "matrix(0.825, -0.565, 0.565, 0.825, 0, 9.856)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281788",
    "data-name": "Path 281788",
    d: "M196.7-167.006a4.989,4.989,0,0,1-4.125-2.169,4.954,4.954,0,0,1-.783-3.736,4.954,4.954,0,0,1,2.08-3.2l7.824-5.358a5,5,0,0,1,6.938,1.3,4.957,4.957,0,0,1,.783,3.736,4.959,4.959,0,0,1-2.082,3.2l-7.824,5.357A4.959,4.959,0,0,1,196.7-167.006Zm7.813-13.315a2.955,2.955,0,0,0-1.674.518l-7.824,5.357a2.949,2.949,0,0,0-1.236,1.9,2.947,2.947,0,0,0,.464,2.223,2.973,2.973,0,0,0,4.128.772L206.2-174.9a2.947,2.947,0,0,0,1.237-1.9,2.944,2.944,0,0,0-.465-2.223A2.967,2.967,0,0,0,204.515-180.321Z",
    transform: "translate(-191.163 182.886)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28474",
    "data-name": "Rectangle 28474",
    width: 32.611,
    height: 51.712,
    rx: 3.367,
    transform: "translate(1.01 1.01)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28475",
    "data-name": "Rectangle 28475",
    width: 24.883,
    height: 38,
    transform: "translate(4.875 7.866)",
    fill: "#85b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281789",
    "data-name": "Path 281789",
    d: "M197.116-137.291H172.233l24.882-38Z",
    transform: "translate(-167.359 183.156)",
    fill: "#6da2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281790",
    "data-name": "Path 281790",
    d: "M196.67-174.954a.124.124,0,0,1,.123.123v37.093a.124.124,0,0,1-.123.123H172.694a.124.124,0,0,1-.124-.123V-174.83a.124.124,0,0,1,.124-.123H196.67m0-1.01H172.694a1.134,1.134,0,0,0-1.135,1.134v37.093a1.134,1.134,0,0,0,1.135,1.134H196.67a1.133,1.133,0,0,0,1.134-1.134V-174.83a1.133,1.133,0,0,0-1.134-1.134Z",
    transform: "translate(-167.366 183.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281791",
    "data-name": "Path 281791",
    d: "M197.628-129.343H171.822a4.418,4.418,0,0,1-4.413-4.413v-44.907a4.418,4.418,0,0,1,4.413-4.413h25.807a4.418,4.418,0,0,1,4.413,4.413v44.907A4.418,4.418,0,0,1,197.628-129.343Zm-25.807-51.712a2.4,2.4,0,0,0-2.392,2.392v44.907a2.4,2.4,0,0,0,2.392,2.392h25.807a2.4,2.4,0,0,0,2.392-2.392v-44.907a2.4,2.4,0,0,0-2.392-2.392Z",
    transform: "translate(-167.409 183.075)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752",
    transform: "translate(22.969 11.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28476",
    "data-name": "Rectangle 28476",
    d: "M3.458,0h5.78a2.6,2.6,0,0,1,2.6,2.6v1.8a2.6,2.6,0,0,1-2.6,2.6H3.458A3.458,3.458,0,0,1,0,3.53V3.458A3.458,3.458,0,0,1,3.458,0Z",
    transform: "translate(3.504 23.878) rotate(-34.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281792",
    "data-name": "Path 281792",
    d: "M198.473-143.042a4.623,4.623,0,0,1-.87-.084,4.472,4.472,0,0,1-2.878-1.9,4.471,4.471,0,0,1-.687-3.377,4.474,4.474,0,0,1,1.9-2.879l4.736-3.2a3.607,3.607,0,0,1,2.724-.554,3.605,3.605,0,0,1,2.321,1.529l.976,1.444a3.638,3.638,0,0,1-.976,5.045l-4.735,3.2A4.458,4.458,0,0,1,198.473-143.042Zm4.224-10.037a1.592,1.592,0,0,0-.9.275l-4.736,3.2a2.461,2.461,0,0,0-1.043,1.586,2.465,2.465,0,0,0,.377,1.862,2.486,2.486,0,0,0,3.449.666l4.735-3.2a1.6,1.6,0,0,0,.678-1.031,1.6,1.6,0,0,0-.245-1.208l-.976-1.444a1.6,1.6,0,0,0-1.031-.677A1.645,1.645,0,0,0,202.7-153.079Z",
    transform: "translate(-190.101 172.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28477",
    "data-name": "Rectangle 28477",
    d: "M3.939,0h8.425a2.829,2.829,0,0,1,2.829,2.829v2.3A2.829,2.829,0,0,1,12.364,7.96H3.939A3.939,3.939,0,0,1,0,4.021V3.939A3.939,3.939,0,0,1,3.939,0Z",
    transform: "translate(0.411 15.574) rotate(-26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281793",
    "data-name": "Path 281793",
    d: "M195.881-149.895a5,5,0,0,1-4.486-2.787,5,5,0,0,1,2.275-6.681l7.5-3.688a3.876,3.876,0,0,1,5.181,1.764l.989,2.012a3.843,3.843,0,0,1,.188,2.954,3.842,3.842,0,0,1-1.951,2.226l-7.5,3.688A4.962,4.962,0,0,1,195.881-149.895Zm6.99-11.532a1.844,1.844,0,0,0-.813.19l-7.5,3.688a2.973,2.973,0,0,0-1.353,3.975,2.974,2.974,0,0,0,3.975,1.353l7.5-3.688a1.836,1.836,0,0,0,.931-1.063,1.832,1.832,0,0,0-.089-1.411l-.989-2.012A1.852,1.852,0,0,0,202.871-161.427ZM205.125-155h0Z",
    transform: "translate(-190.133 172.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28478",
    "data-name": "Rectangle 28478",
    d: "M3.939,0h8.425a2.829,2.829,0,0,1,2.829,2.829v2.3A2.829,2.829,0,0,1,12.364,7.96H3.939A3.939,3.939,0,0,1,0,4.021V3.939A3.939,3.939,0,0,1,3.939,0Z",
    transform: "translate(0 6.748) rotate(-26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281794",
    "data-name": "Path 281794",
    d: "M195.478-158.63a5.043,5.043,0,0,1-1.62-.27,4.962,4.962,0,0,1-2.871-2.517,4.957,4.957,0,0,1-.241-3.809,4.953,4.953,0,0,1,2.517-2.871l7.5-3.688a3.875,3.875,0,0,1,5.181,1.763l.989,2.013a3.843,3.843,0,0,1,.188,2.954,3.843,3.843,0,0,1-1.952,2.226l-7.5,3.687A4.946,4.946,0,0,1,195.478-158.63Zm6.986-11.531a1.831,1.831,0,0,0-.813.19l-7.5,3.688a2.944,2.944,0,0,0-1.5,1.709,2.943,2.943,0,0,0,.142,2.265,2.943,2.943,0,0,0,1.709,1.5,2.941,2.941,0,0,0,2.266-.141l7.5-3.688a1.838,1.838,0,0,0,.931-1.064,1.837,1.837,0,0,0-.089-1.411l-.989-2.012A1.851,1.851,0,0,0,202.464-170.161Z",
    transform: "translate(-190.137 172.182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753",
    transform: "translate(12.011 20.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281795",
    "data-name": "Path 281795",
    d: "M189.906-156.045v4.547a1.137,1.137,0,0,1-1.137,1.137h-8.336A1.137,1.137,0,0,1,179.3-151.5v-4.547a1.137,1.137,0,0,1,1.137-1.137H181v-1.7a3.605,3.605,0,0,1,3.6-3.6,3.6,3.6,0,0,1,3.6,3.6v1.7h.569A1.137,1.137,0,0,1,189.906-156.045Zm-3.6-2.841a1.707,1.707,0,0,0-1.7-1.706,1.707,1.707,0,0,0-1.706,1.706v1.7h3.41Z",
    transform: "translate(-179.296 162.487)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756",
    transform: "translate(0 21.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755",
    transform: "translate(1.01 1.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281796",
    "data-name": "Path 281796",
    d: "M166.255-102.193v-21.2l-3.606-4.948c-1.621-2.223-2.494-8.3-2.494-11.056v-17.443a4.17,4.17,0,0,1,4.17-4.169h0a4.17,4.17,0,0,1,4.17,4.169v16.331s9.052,1.32,12.033,8.423c.587,1.4.939,1.5.939,1.5h14.541c-.866,4.921-3.5,7.121-5.287,8.069a3.288,3.288,0,0,0-1.766,2.908v17.413Z",
    transform: "translate(-160.155 161.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281797",
    "data-name": "Path 281797",
    d: "M180.339-132.352a11.546,11.546,0,0,0-2.126-3.305c2.694,3.009,3.122,8.065,3.134,10.857a1.979,1.979,0,0,0,2.257,1.936,28.017,28.017,0,0,0,7.775-2.331,7.807,7.807,0,0,0,4.432-5.608l.008-.045H181.279S180.927-130.951,180.339-132.352Z",
    transform: "translate(-159.966 161.275)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281798",
    "data-name": "Path 281798",
    d: "M160.155-156.841V-139.4c0,2.75.873,8.832,2.493,11.055l2.861,3.924a3.9,3.9,0,0,1,.747,2.294v19.932h7.033v-11.464a4.819,4.819,0,0,1,.546-2.232c.264-.5.6-1.193.943-1.929a13.376,13.376,0,0,0,.564-10.335,6.084,6.084,0,0,0-.373-.835,16.588,16.588,0,0,0-8.772-7.045,2.871,2.871,0,0,1-1.87-2.7V-161.01A4.17,4.17,0,0,0,160.155-156.841Z",
    transform: "translate(-160.155 161.01)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_281799",
    "data-name": "Path 281799",
    d: "M166.267-101.172a1.01,1.01,0,0,1-1.01-1.01V-122.1a2.9,2.9,0,0,0-.56-1.718l-2.854-3.914c-1.79-2.454-2.688-8.793-2.688-11.651v-17.442a5.186,5.186,0,0,1,5.181-5.181,5.186,5.186,0,0,1,5.181,5.181v15.5A21.363,21.363,0,0,1,175.5-139a13.192,13.192,0,0,1,6.985,11.827,1.011,1.011,0,0,1-1.01,1.01,1.011,1.011,0,0,1-1.01-1.01c0-10.446-11.987-12.314-12.107-12.331l-.865-.126v-17.2a3.163,3.163,0,0,0-3.16-3.16,3.163,3.163,0,0,0-3.16,3.16v17.442c0,2.909.917,8.565,2.3,10.461l2.854,3.914a4.906,4.906,0,0,1,.948,2.908v19.921A1.011,1.011,0,0,1,166.267-101.172Z",
    transform: "translate(-159.155 162.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281800",
    "data-name": "Path 281800",
    d: "M188.668-101.487a1.011,1.011,0,0,1-1.01-1.01V-119.91a4.3,4.3,0,0,1,2.3-3.8c1.746-.925,3.989-2.949,4.764-7.351a1.009,1.009,0,0,1,1.17-.82,1.011,1.011,0,0,1,.82,1.17c-.965,5.482-4.054,7.858-5.809,8.788a2.281,2.281,0,0,0-1.229,2.015V-102.5A1.011,1.011,0,0,1,188.668-101.487Z",
    transform: "translate(-158.857 162.325)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762",
    transform: "translate(217.627 -176.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28479",
    "data-name": "Rectangle 28479",
    d: "M5,0H87.74a5,5,0,0,1,5,5V65.685a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(11.663 1.01)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758",
    transform: "translate(0 65.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28480",
    "data-name": "Rectangle 28480",
    d: "M0,0H114.045a0,0,0,0,1,0,0V.085a8.157,8.157,0,0,1-8.157,8.157H8.157A8.157,8.157,0,0,1,0,.085V0A0,0,0,0,1,0,0Z",
    transform: "translate(1.01 1.01)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281801",
    "data-name": "Path 281801",
    d: "M225.969-102.768H323.53a8.22,8.22,0,0,0,6.5-3.19H219.467A8.219,8.219,0,0,0,225.969-102.768Z",
    transform: "translate(-216.717 112.021)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281802",
    "data-name": "Path 281802",
    d: "M323.558-101.695H226a9.263,9.263,0,0,1-9.253-9.253,1.011,1.011,0,0,1,1.01-1.01H331.8a1.011,1.011,0,0,1,1.01,1.01A9.263,9.263,0,0,1,323.558-101.695Zm-104.722-8.242A7.243,7.243,0,0,0,226-103.716h97.561a7.243,7.243,0,0,0,7.161-6.221Z",
    transform: "translate(-216.745 111.958)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_281803",
    "data-name": "Path 281803",
    d: "M322.049-109.258H227.287V-170.9a6.069,6.069,0,0,1,6.063-6.063h82.636a6.069,6.069,0,0,1,6.063,6.063Zm-92.741-2.021h90.72V-170.9a4.047,4.047,0,0,0-4.042-4.042H233.35a4.047,4.047,0,0,0-4.042,4.042Z",
    transform: "translate(-216.635 176.964)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760",
    transform: "translate(17.151 7.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28481",
    "data-name": "Rectangle 28481",
    width: 81.764,
    height: 55.221,
    rx: 2.202,
    fill: "#85b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281804",
    "data-name": "Path 281804",
    d: "M313.257-114.088H235.944a2.225,2.225,0,0,1-2.225-2.225l81.763-50.771v50.771A2.225,2.225,0,0,1,313.257-114.088Z",
    transform: "translate(-233.719 169.309)",
    fill: "#6da2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281805",
    "data-name": "Path 281805",
    d: "M313.257-168.276a1.216,1.216,0,0,1,1.215,1.215v50.771a1.216,1.216,0,0,1-1.215,1.215H235.944a1.216,1.216,0,0,1-1.215-1.215v-50.771a1.216,1.216,0,0,1,1.215-1.215h77.313m0-1.01H235.944a2.225,2.225,0,0,0-2.225,2.225v50.771a2.225,2.225,0,0,0,2.225,2.225h77.313a2.225,2.225,0,0,0,2.225-2.225v-50.771a2.225,2.225,0,0,0-2.225-2.225Z",
    transform: "translate(-233.719 169.286)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759",
    transform: "translate(29.172 13.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281806",
    "data-name": "Path 281806",
    d: "M286.009-141.986v10.037a2.511,2.511,0,0,1-2.51,2.51H265.1a2.51,2.51,0,0,1-2.509-2.51v-10.037a2.51,2.51,0,0,1,2.509-2.51h1.255v-3.764a7.957,7.957,0,0,1,7.946-7.946,7.957,7.957,0,0,1,7.946,7.946v3.764H283.5A2.511,2.511,0,0,1,286.009-141.986Zm-7.946-6.274a3.768,3.768,0,0,0-3.764-3.764,3.767,3.767,0,0,0-3.764,3.764v3.764h7.528Z",
    transform: "translate(-262.589 156.206)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_281807",
    "data-name": "Path 281807",
    d: "M274.195-170.347a1.623,1.623,0,0,1-1.621-1.621,1.623,1.623,0,0,1,1.621-1.621,1.623,1.623,0,0,1,1.621,1.621A1.623,1.623,0,0,1,274.195-170.347Zm0-2.231a.611.611,0,0,0-.61.61.611.611,0,0,0,.61.61.611.611,0,0,0,.61-.61A.611.611,0,0,0,274.195-172.578Z",
    transform: "translate(-216.162 176.999)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllNewterms);
export default __webpack_public_path__ + "static/media/ill_newterms.493abac84238cb9024c12a25c7599a57.svg";
export { ForwardRef as ReactComponent };